import { useContext } from 'react';
import { OrigamiUIEvent, EventContext, OrigamiElement } from './EventProvider';

// eslint-disable-next-line @typescript-eslint/no-empty-function
function noop() {}

function useEvents<T extends OrigamiUIEvent>(
  eventId: string | null | undefined,
  element: OrigamiElement
): (payload: Omit<T, 'eventId' | 'element'>) => void {
  const handler = useContext(EventContext);
  if (!eventId) return noop;
  return (payload) =>
    handler({
      eventId,
      element,
      ...payload,
    });
}

export default useEvents;
